/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import classNames from 'classnames';

import { Link } from '@fluentui/react';
import { ImageFit } from '@fluentui/react/lib/Image';
import {
  ImageOptionsKey,
  SelectImagesListViewWithSearch,
  SmartImage,
} from '@bingads-webui-campaign-react/smart-component-image';

const IMAGE_WIDTH = 210;
const IMAGE_HEIGHT = 175;
const PAGE_HEIGHT = 432;

export const getImageOptionsConfigForPivot = ({
  i18n,
  onStockImageItemSelectionChanged,
  defaultKeywords,
  enableFacebookImport,
  gotoSettings,
  classes,
  facebookImageInfo,
}) => (
  {
    [ImageOptionsKey.DEFAULT]: {
      text: _TL_('Stock image'),
      onRenderItemLink: () => (
        <div className={classes.editorPivotStyleContentClassName}>
          <SelectImagesListViewWithSearch
            onItemSelectionChanged={onStockImageItemSelectionChanged}
            pageHeight={PAGE_HEIGHT}
            imageWidth={IMAGE_WIDTH}
            imageHeight={IMAGE_HEIGHT}
            isMultiple={false}
            i18n={i18n}
            itemsPerPage={4}
            defaultKeywords={defaultKeywords}
          />
        </div>
      ),
    },
    [ImageOptionsKey.FACEBOOKIMPORT]: {
      text: _TL_('From Facebook'),
      onRenderItemLink: () => {
        let labelText = _TL_('Sync your Facebook Business Page with your Smart Page to use the same cover image.');
        let fbContent = (
          <Link
            className="go-to-settings-page-link"
            onClick={gotoSettings}
          >
            {i18n.getString(_TL_('Connect your accounts now'))}
          </Link>);

        if (enableFacebookImport) {
          labelText = _TL_('Use your Facebook Business Page\'s cover photo.');
          fbContent = facebookImageInfo ?
            (
              <SmartImage
                imageId={facebookImageInfo.IdString}
                resizeWidth={435}
                height={300}
                width={435}
                imageFit={ImageFit.contain}
              />
            ) : null;
        }

        return (
          <div className={classNames(classes.editorPivotStyleContentClassName, 'facebook-cover-image-import-content')}>
            <p className="facebook-cover-image-description">{i18n.getString(labelText)}</p>
            <div className="facebook-cover-image-content-container">
              {fbContent}
            </div>
          </div>
        );
      },
    },
  }
);
